import { render, staticRenderFns } from "./fee-fixo-ia-envio-relatorio.vue?vue&type=template&id=004061b9&scoped=true&"
import script from "./fee-fixo-ia-envio-relatorio.vue?vue&type=script&lang=js&"
export * from "./fee-fixo-ia-envio-relatorio.vue?vue&type=script&lang=js&"
import style0 from "./fee-fixo-ia-envio-relatorio.vue?vue&type=style&index=0&id=004061b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004061b9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004061b9')) {
      api.createRecord('004061b9', component.options)
    } else {
      api.reload('004061b9', component.options)
    }
    module.hot.accept("./fee-fixo-ia-envio-relatorio.vue?vue&type=template&id=004061b9&scoped=true&", function () {
      api.rerender('004061b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-fixo-ia-envio-relatorio/fee-fixo-ia-envio-relatorio.vue"
export default component.exports